export default "<!-- Check permission -->\n<app-permission-manager></app-permission-manager>\n\n<!-- Menu bar -->\n<app-menu-manager></app-menu-manager>"